import { enTranslations } from './translations.en';

export const arTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': 'نظرة عامة',
  'nav.overviewDesc': 'الحالة التشغيلية والتنسيق وقنوات التسليم',
  'nav.reception': 'الاستقبال',
  'nav.receptionDesc': 'القوائم التشغيلية والإصدار اليدوي والرفع الجماعي',
  'nav.administration': 'الإدارة',
  'nav.administrationDesc':
    'قوائم ونماذج مخصصة للمستأجرين والمورّدين والمواقع والمستخدمين والبنية التحتية',
  'shell.consoleTitle': 'وحدة التشغيل',
  'shell.consoleDescription':
    'لوحة تحكم متعددة المستأجرين لتدفقات PMS وعمليات الاستقبال وتهيئة متحكم الشبكة وتوزيع DPSK.',
  'shell.livePosture': 'الحالة المباشرة',
  'shell.loadingLocation': 'جارٍ تحميل سياق الموقع',
  'shell.healthy': 'تدفق تشغيلي مستقر',
  'shell.attention': 'مطلوب الانتباه لقناة التسليم',
  'shell.authSession': 'جلسة موثقة',
  'shell.guestOperator': 'مشغل تجريبي',
  'shell.noRole': 'لا يوجد دور',
  'shell.currentWorkspace': 'مساحة العمل الحالية',
  'shell.workspaceDescription': 'السياق النشط للصفحة المحددة.',
  'shell.filters': 'الفلاتر',
  'shell.tenant': 'المستأجر',
  'shell.location': 'الفندق / الموقع',
  'shell.language': 'اللغة',
  'shell.theme': 'السمة',
  'shell.theme.system': 'النظام',
  'shell.theme.light': 'فاتح',
  'shell.loadingData': 'جارٍ تحديث البيانات',
  'shell.searchTenant': 'ابحث عن مستأجر',
  'shell.searchLocation': 'ابحث عن فندق أو موقع',
  'shell.noSearchResults': 'لا توجد نتائج',
  'shell.closeFilters': 'إغلاق الفلاتر',
  'dialog.cancel': 'إلغاء',
  'dialog.deleteTitle': 'تأكيد الحذف',
  'dialog.extendTitle': 'تأكيد التمديد',
  'dialog.revokeTitle': 'تأكيد الإلغاء',
  'shell.noPms': 'لا يوجد PMS مرتبط',
  'shell.noController': 'لا يوجد متحكم مرتبط',
  'shell.tvOn': 'التلفاز مفعّل',
  'shell.tvPending': 'التلفاز قيد الانتظار',
  'shell.emailOn': 'البريد الإلكتروني مفعّل',
  'shell.emailPending': 'البريد الإلكتروني قيد الانتظار',
  'shell.exitSession': 'تسجيل الخروج',
  'auth.mode.mock': 'الوضع التجريبي',
  'login.badge': 'وحدة تشغيل hospitality',
  'login.title': 'وصول آمن إلى منصة hospitality.',
  'login.description':
    'أدر المستأجرين والمواقع والمستخدمين والمورّدين وبيانات اعتماد Wi‑Fi من وحدة تحكم واحدة مخصصة للتشغيل اليومي.',
  'login.inputTitle': 'المستأجرون والمواقع',
  'login.inputBody': 'تحكم في المنشآت والوحدات والمورّدين والإعدادات التشغيلية من مكان واحد.',
  'login.logicTitle': 'الاستقبال وبيانات الاعتماد',
  'login.logicBody': 'أنشئ وجدّد وراقب رموز Wi‑Fi للضيوف والموظفين والفعاليات بدون خطوات إضافية.',
  'login.outputTitle': 'رؤية تشغيلية',
  'login.outputBody': 'اطّلع سريعًا على حالة الخدمة والطوابير وتسليم بيانات الاعتماد.',
  'login.accessMode': 'تسجيل الدخول',
  'login.demoWorkspace': 'استكشاف المنصة',
  'login.keycloakWorkspace': 'مرحبًا بعودتك',
  'login.demoDescription': 'افتح البيئة التجريبية لاستكشاف المسارات الرئيسية باستخدام بيانات نموذجية.',
  'login.keycloakDescription': 'سجّل الدخول باستخدام حساب الشركة للمتابعة.',
  'login.enterDemo': 'فتح لوحة العرض التجريبية',
  'login.continueKeycloak': 'الدخول إلى المنصة',
  'login.readyTitle': 'إدارة مركزية',
  'login.readyBody': 'المستأجرون والمواقع والوحدات والمستخدمون والكتالوجات متاحة من خلال وحدة تشغيل واحدة.',
  'login.supportTitle': 'عمليات يومية',
  'login.supportBody': 'اعمل على تدفقات الاستقبال وبيانات اعتماد Wi‑Fi وإعدادات الخدمة ضمن تجربة أبسط.',
  'login.demoNote': 'البيئة التجريبية تستخدم بيانات نموذجية وهي مخصّصة للاستكشاف فقط.',
  'login.switchNote': 'إذا واجهت مشكلة في تسجيل الدخول، تواصل مع مسؤول الخدمة.',
  'overview.context': 'نظرة تشغيلية',
  'overview.title': 'حالة الموقع المحدد',
  'overview.subtitle': 'مؤشرات سريعة عن استخدام DPSK وربط VLAN والحمولة التشغيلية للموقع.',
  'reception.pageKicker': 'عمليات الاستقبال',
  'reception.pageTitle': 'إصدار DPSK وإدارة دورة الحياة',
  'reception.pageDescription':
    'منطقة الاستقبال منظمة في صفحات مخصصة: قائمة الرموز، الإصدار اليدوي، والرفع الجماعي.',
  'admin.pageKicker': 'الإدارة',
  'admin.pageTitle': 'المستأجرون والمورّدون والمواقع والمستخدمون',
  'admin.pageDescription':
    'تستخدم المنطقة الإدارية صفحات مخصصة للمستأجرين وكتالوجات المورّدين والمواقع والمستخدمين والبنية التحتية.',
  'admin.actions.newRoomAssignment': 'وحدة جديدة',
  'admin.actions.assignRoom': 'تعديل الوحدة',
  'admin.form.createRoomAssignment': 'إنشاء وحدة',
  'admin.form.updateRoomAssignment': 'تحديث الوحدة',
  'admin.form.roomAssignmentDescription':
    'حدّد تعيين Wi‑Fi لوحدة واحدة. تصبح التهيئة متاحة فورًا في جرد الموقع وفي تدفقات الاستقبال.',
  'admin.form.roomNotFound': 'الوحدة غير موجودة.',
  'admin.form.locationRequiredForRoom': 'حدّد موقعًا أولًا قبل تسجيل وحدة.',
  'admin.message.roomAssignmentSaved': 'تم حفظ إعداد البنية التحتية لـ {name}.',
  'table.pagination.previous': 'السابق',
  'table.pagination.next': 'التالي',
  'table.pagination.summary': '{from}-{to} من {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': 'الهويات النشطة',
  'overview.card.active.caption': 'رموز DPSK الصالحة حاليًا في الموقع المحدد',
  'overview.card.scheduled.label': 'الوصولات المجدولة',
  'overview.card.scheduled.caption': 'تم إنشاء بيانات الاعتماد بالفعل وهي بانتظار تسجيل الوصول أو بدء الفعالية',
  'overview.card.mapped.label': 'الوحدات المعينة',
  'overview.card.mapped.caption': '{rooms} غرف، {publicAreas} مناطق مشتركة، {eventHalls} قاعات فعاليات',
  'overview.card.daily.label': 'الحجم اليومي',
  'overview.card.daily.caption': 'الحمل المتوقع بين PMS والاستقبال والطلبات اليدوية',
  'overview.locationHealth': 'حالة الخدمات',
  'overview.deliveryChannels': 'قنوات التسليم',
  'overview.connected': 'متصل',
  'overview.fallback': 'البديل الاحتياطي مفعّل',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'تبقى سجلات RADIUS مركزية لأغراض الامتثال والتحليلات.',
  'overview.operationalFlow': 'التدفق التشغيلي',
  'overview.flowAligned': 'متوافق مع سيناريوهات الوثيقة',
  'overview.channelMix': 'مزيج القنوات',
  'overview.distributionSplit': 'توزيع التسليم',
  'overview.channelShare': '{share}% من الإجمالي الظاهر',
  'overview.infrastructure': 'الوحدات و VLAN',
  'overview.infrastructureDesc': 'الغرف والمناطق المشتركة وقاعات الفعاليات المتاحة في هذا الموقع.',
  'overview.alerts': 'لوحة التنبيهات',
  'overview.alertsTitle': 'المخاطر والحالات الشاذة الحالية',
  'overview.noAlerts': 'لا توجد حالات شاذة مفتوحة في الموقع الحالي.',
  'overview.queue': 'الطابور الخلفي',
  'overview.queueTitle': 'حالة الاستيراد الجماعي',
  'overview.queueProgress': 'تمت معالجة {processed}/{total}، وVLAN الهدف {vlan}',
  'overview.credentials': 'بيانات الاعتماد الأخيرة',
  'overview.credentialsTitle': 'أحدث رموز DPSK التي تم إصدارها',
  'overview.table.guest': 'الضيف',
  'overview.table.space': 'الوحدة',
  'overview.table.type': 'النوع',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'وضع PAN',
  'overview.table.source': 'المصدر',
  'overview.table.channels': 'القنوات',
  'overview.table.validity': 'الصلاحية',
  'overview.table.devices': 'الأجهزة',
  'overview.flow.trigger.title': 'تشغيل PMS / الاستقبال',
  'overview.flow.trigger.body': 'ينتج webhook أو نموذج المشغّل أو ملف CSV طلب الوصول.',
  'overview.flow.normalize.title': 'توحيد الهوية',
  'overview.flow.normalize.body':
    'تقوم المنصة بتعيين الفندق والوحدة وVLAN ونافذة الصلاحية الزمنية.',
  'overview.flow.provision.title': 'تهيئة متحكم الشبكة',
  'overview.flow.provision.body':
    'يتم ربط DPSK مع VLAN المعين ومع نافذة دورة حياته.',
  'overview.flow.deliver.title': 'التسليم عبر القنوات',
  'overview.flow.deliver.body': 'يتلقى التلفاز أو البريد الإلكتروني أو اللوحة أو الطباعة رمز QR وكلمة المرور.',
  'overview.flow.monitor.title': 'المراقبة وAccounting',
  'overview.flow.monitor.body':
    'يبقى الاستخدام والطوابير واعتماد القنوات وaccounting مرئيًا لفريق operations.',
  'validation.required': 'حقل مطلوب.',
  'validation.email': 'أدخل بريدًا إلكترونيًا صالحًا.',
  'validation.minValue': 'أدخل قيمة صالحة.',
  'validation.fixErrors': 'صحّح الحقول المميزة قبل الحفظ.',
  'validation.dateOrder': 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البداية.',
  'validation.selectOne': 'اختر عنصرًا واحدًا على الأقل.',
  'toast.dismiss': 'إغلاق الإشعار',
  'toast.error.network': 'تعذر الوصول إلى خدمة الخلفية.',
  'toast.error.badRequest': 'الطلب غير صالح.',
  'toast.error.unauthorized': 'الجلسة غير مصرح بها. يرجى تسجيل الدخول مرة أخرى.',
  'toast.error.forbidden': 'ليست لديك الصلاحيات اللازمة لإكمال هذه العملية.',
  'toast.error.notFound': 'لم يتم العثور على المورد المطلوب.',
  'toast.error.conflict': 'لا يمكن إكمال العملية بسبب تعارض في الحالة.',
  'toast.error.validation': 'البيانات المرسلة غير صالحة.',
  'toast.error.server': 'أعاد الخادم خطأً داخليًا.',
  'toast.error.unavailable': 'الخدمة غير متاحة مؤقتًا.',
  'toast.error.genericStatus': 'خطأ HTTP {status}: فشل الطلب.',
  'toast.error.unexpected': 'حدث خطأ غير متوقع أثناء طلب HTTP.',
  'channel.tv': 'التلفاز',
  'channel.email': 'البريد الإلكتروني',
  'channel.dashboard': 'لوحة التحكم',
  'channel.print': 'طباعة',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'الاستقبال',
  'codeSource.bulk': 'جماعي',
  'queueStatus.queued': 'في الطابور',
  'queueStatus.running': 'قيد التنفيذ',
  'queueStatus.completed': 'مكتمل',
  'queueStatus.attention': 'انتباه',
  'spaceKind.room': 'غرفة',
  'spaceKind.public-area': 'منطقة مشتركة',
  'spaceKind.event-hall': 'قاعة فعاليات',
  'assignment.room': 'غرفة',
  'assignment.group': 'مجموعة',
  'assignment.common': 'مشترك',
  'panMode.private': 'خاص',
  'panMode.shared-group': 'مجموعة مشتركة',
  'panMode.public': 'عام',
  'role.tv-integration': 'تكامل التلفاز',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'المسؤول',
  'role.reception': 'خدمة النزلاء',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'فندق',
  'locationCategory.resort': 'منتجع',
  'locationCategory.conference': 'موقع مؤتمرات',
  'locationState.active': 'نشط',
  'locationState.disabled': 'معطل',
  'locationState.pending': 'قيد الانتظار',
  'locationState.stable': 'مستقر',
  'locationState.attention': 'انتباه',
  'unitStatus.available': 'متاحة',
  'unitStatus.disabled': 'معطلة',
  'unitStatus.occupied': 'مشغولة',
  'userStatus.active': 'نشط',
  'userStatus.invited': 'مدعو',
  'userStatus.disabled': 'معطل',
  'reception.tab.issue': 'إصدار',
  'reception.tab.codes': 'إدارة الرموز',
  'reception.tab.bulk': 'رفع جماعي',
  'reception.summary.active': 'نشطة',
  'reception.summary.scheduled': 'مجدولة',
  'reception.summary.archived': 'مؤرشفة',
  'reception.summary.queue': 'مهام جماعية',
  'reception.issue.kicker': 'إصدار يدوي',
  'reception.issue.title': 'إنشاء DPSK للضيوف والحالات الاستثنائية',
  'reception.issue.description':
    'للحالات المباشرة والموردين والوصول إلى البار أو كبديل عند تعذر PMS. أنشئ رمز QR وكلمة مرور بنص واضح.',
  'reception.fields.firstName': 'الاسم',
  'reception.fields.lastName': 'اسم العائلة',
  'reception.fields.email': 'البريد الإلكتروني',
  'reception.fields.space': 'الوحدة',
  'reception.fields.reference': 'مرجع الحجز / voucher',
  'reception.fields.validFrom': 'صالح من',
  'reception.fields.validUntil': 'صالح حتى',
  'reception.fields.devicesAllowed': 'الأجهزة المسموح بها',
  'reception.fields.deliveryChannels': 'قنوات التسليم',
  'reception.fields.notes': 'ملاحظات المشغل',
  'reception.preview.kicker': 'معاينة القسيمة',
  'reception.preview.title': 'بطاقة المشغل',
  'reception.preview.empty': 'اختر وحدة لمعاينة رمز QR.',
  'reception.preview.guest': 'الضيف',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'وضع PAN',
  'reception.preview.expires': 'انتهاء الصلاحية',
  'reception.lastCreated': 'آخر رمز تم إنشاؤه',
  'reception.lastCreatedEmpty': 'أنشئ DPSK يدويًا لعرض آخر ملخص للقسيمة هنا.',
  'reception.generate': 'إنشاء DPSK',
  'reception.creating': 'جارٍ الإنشاء...',
  'reception.codes.kicker': 'إدارة الرموز',
  'reception.codes.title': 'تصفية القسائم أو تمديدها أو إلغاؤها',
  'reception.filter.all': 'الكل',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'الاستقبال',
  'reception.filter.bulk': 'جماعي',
  'reception.searchPlaceholder': 'ابحث عن ضيف أو مرجع',
  'reception.activeList': 'نشطة / مجدولة',
  'reception.archivedList': 'مؤرشفة / غير صالحة',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'إلغاء',
  'reception.actions.new': 'DPSK جديدة',
  'reception.actions.backToCodes': 'العودة إلى الرموز',
  'reception.actions.showQr': 'عرض QR',
  'reception.actions.printQr': 'طباعة QR',
  'reception.confirm.extend': 'تمديد قسيمة {name} لمدة 24 ساعة؟',
  'reception.confirm.revoke': 'إلغاء قسيمة {name}؟',
  'reception.activeEmpty': 'لا توجد رموز نشطة أو مجدولة تطابق الفلاتر الحالية.',
  'reception.archivedEmpty': 'لا توجد رموز مؤرشفة أو ملغاة تطابق الفلاتر الحالية.',
  'reception.bulk.kicker': 'إدخال جماعي',
  'reception.bulk.title': 'استيراد CSV للمجموعات والفعاليات',
  'reception.bulk.loadFile': 'تحميل ملف',
  'reception.bulk.mode': 'وضع الرفع الجماعي',
  'reception.bulk.modeShared': 'VLAN مجموعة مشتركة',
  'reception.bulk.modeIsolated': 'VLAN / عزل لكل وحدة',
  'reception.bulk.defaultSpace': 'الوحدة الافتراضية',
  'reception.bulk.requestedBy': 'طُلب بواسطة',
  'reception.bulk.csvBody': 'محتوى CSV',
  'reception.bulk.queue': 'وضع الاستيراد في الطابور',
  'reception.bulk.queueing': 'جارٍ وضعه في الطابور...',
  'reception.bulk.templateHint':
    'الأعمدة المتوقعة: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'حالة الطابور',
  'reception.bulk.jobsTitle': 'النشاط الأخير',
  'reception.emptyLocation': 'اختر موقعًا يحتوي على وحدات متاحة أو أنشئ واحدًا.',
  'reception.message.created': 'تم إنشاء {id} لـ {name}.',
  'reception.message.bulkQueued': 'تم وضع المهمة {id} في الطابور مع {imported} هويات ({status}).',
  'reception.message.extended': 'تم تمديد صلاحية {id} لمدة 24 ساعة.',
  'reception.message.revoked': 'تم إلغاء الرمز {id}.',
  'admin.vendorHintTitle': 'كتالوجات المورّدين',
  'admin.vendorHintBody':
    'قبل إنشاء موقع أو تحديثه يمكنك تسجيل كتالوجات مورّدي المتحكم و PMS بحيث تكون القوائم المنسدلة وحقول الإعداد جاهزة داخل نماذج الموقع.',
  'admin.card.tenants.label': 'المستأجرون',
  'admin.card.tenants.caption': 'محفظة متعددة المستأجرين تتم إدارتها من اللوحة',
  'admin.card.locations.label': 'المواقع',
  'admin.card.locations.caption': 'الفنادق والمنتجعات ومواقع الفعاليات المتاحة في النموذج الأولي',
  'admin.card.users.label': 'المستخدمون',
  'admin.card.users.caption': 'الأدوار التشغيلية والتعيينات تُدار عبر الحالة الوهمية',
  'admin.card.spaces.label': 'الوحدات / VLAN',
  'admin.card.spaces.caption': 'مخزون الوحدات الحالي للموقع المحدد',
  'admin.tab.tenants': 'المستأجرون',
  'admin.tab.locations': 'المواقع',
  'admin.tab.users': 'المستخدمون',
  'admin.tab.controllerVendors': 'موردو المتحكم',
  'admin.tab.pmsVendors': 'موردو PMS',
  'admin.tab.infrastructure': 'البنية التحتية',
  'admin.tenants.kicker': 'إدارة المستأجرين',
  'admin.tenants.title': 'إنشاء المستأجرين وتحديثهم',
  'admin.locations.kicker': 'إدارة المواقع',
  'admin.locations.title': 'إدارة الفنادق والمنتجعات ومواقع الفعاليات',
  'admin.locations.filterHint':
    'اختر مستأجرًا لإظهار المواقع المرتبطة به فقط من دون استخدام الفلاتر التشغيلية العامة.',
  'admin.users.kicker': 'إدارة المستخدمين',
  'admin.users.title': 'الأدوار ونطاقات المستأجر ونطاقات الموقع',
  'admin.controllerVendors.kicker': 'كتالوج المتحكم',
  'admin.controllerVendors.title': 'تسجيل موردي المتحكم وإدارتهم',
  'admin.controllerVendors.empty': 'لا يوجد أي مورد متحكم مسجل حتى الآن.',
  'admin.controllerVendors.emptyHint':
    'أضف أول مورد متحكم ليصبح متاحًا أثناء تهيئة المواقع.',
  'admin.pmsVendors.kicker': 'كتالوج PMS',
  'admin.pmsVendors.title': 'تسجيل موردي PMS وإدارتهم',
  'admin.pmsVendors.empty': 'لا يوجد أي مورد PMS مسجل حتى الآن.',
  'admin.pmsVendors.emptyHint':
    'أضف أول مورد PMS ليصبح متاحًا أثناء تهيئة المواقع.',
  'admin.infrastructure.kicker': 'المخزون والتكاملات',
  'admin.infrastructure.title': 'الوحدات و VLAN وجاهزية الموصلات',
  'admin.form.new': 'جديد',
  'admin.form.reset': 'إعادة تعيين',
  'admin.form.create': 'إنشاء',
  'admin.form.update': 'تحديث',
  'admin.form.name': 'الاسم',
  'admin.form.brand': 'العلامة / الوصف',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'تغطية DPSK %',
  'admin.form.city': 'المدينة',
  'admin.form.category': 'الفئة',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'مورد PMS',
  'admin.form.pds': 'إعداد PDS',
  'admin.form.controller': 'المتحكم',
  'admin.form.controllerVendor': 'مورد المتحكم',
  'admin.form.tv': 'تكامل التلفاز',
  'admin.form.email': 'تكامل البريد الإلكتروني',
  'admin.form.integrations': 'التكاملات',
  'admin.form.state': 'الحالة',
  'admin.form.dailyCheckIns': 'تسجيلات الوصول اليومية',
  'admin.form.activeGuests': 'الضيوف النشطون',
  'admin.form.bulkQueue': 'طابور الرفع الجماعي',
  'admin.form.note': 'ملاحظة تشغيلية',
  'admin.form.timezone': 'المنطقة الزمنية',
  'admin.form.linkedTenant': 'المستأجر المرتبط',
  'admin.form.role': 'الدور',
  'admin.form.status': 'حالة المستخدم',
  'admin.form.tenantScope': 'نطاق المستأجر',
  'admin.form.locationScope': 'نطاق الموقع',
  'admin.form.fieldSchema': 'مخطط الحقول',
  'admin.form.fieldName': 'اسم الحقل',
  'admin.form.fieldType': 'نوع الحقل',
  'admin.form.fieldsHelp': 'عرّف حقلاً إضافيًا واحدًا على الأقل للمورّد.',
  'admin.form.selectVendor': 'اختر مورّدًا',
  'admin.form.selectVendorFirst': 'اختر مورّدًا أولاً لتكوين الحقول المطلوبة.',
  'admin.form.pmsConfiguration': 'إعداد PMS',
  'admin.form.controllerConfiguration': 'إعداد المتحكم',
  'admin.form.vendorConfigurationHint':
    'املأ جميع الحقول المطلوبة في مدخل كتالوج المورّد المحدد.',
  'admin.form.noPmsVendorsAvailable':
    'لا يوجد أي مورد PMS متاح حتى الآن. سجّل كتالوج PMS أولاً.',
  'admin.form.noControllerVendorsAvailable':
    'لا يوجد أي مورد متحكم متاح حتى الآن. سجّل كتالوج المتحكم أولاً.',
  'admin.form.addField': 'إضافة حقل',
  'admin.form.removeField': 'إزالة الحقل',
  'admin.form.createControllerVendor': 'إنشاء مورد متحكم',
  'admin.form.createPmsVendor': 'إنشاء مورد PMS',
  'admin.form.updateControllerVendor': 'تحديث مورد المتحكم',
  'admin.form.updatePmsVendor': 'تحديث مورد PMS',
  'admin.form.controllerVendorNotFound': 'مورد المتحكم غير موجود.',
  'admin.form.pmsVendorNotFound': 'مورد PMS غير موجود.',
  'admin.form.vendorFieldType.string': 'نص',
  'admin.form.vendorFieldType.number': 'رقم',
  'admin.form.vendorFieldType.boolean': 'منطقي',
  'admin.form.vendorFieldType.password': 'كلمة مرور',
  'admin.form.unitType': 'نوع الوحدة',
  'admin.form.assignment': 'الإسناد',
  'admin.form.unitStatus': 'حالة الوحدة',
  'admin.list.portfolio': 'المحفظة',
  'admin.list.properties': 'المنشآت',
  'admin.list.coverage': 'التغطية',
  'admin.list.alerts': 'التنبيهات',
  'admin.list.noneTenants': 'لا يوجد أي مستأجر مسجل حتى الآن.',
  'admin.list.noneLocations': 'لا توجد مواقع متاحة للمستأجر المحدد.',
  'admin.tenants.emptyHint': 'أنشئ أول مستأجر لبدء تهيئة المنصة متعددة المستأجرين.',
  'admin.actions.edit': 'تعديل',
  'admin.actions.toggleStatus': 'تبديل الحالة',
  'admin.actions.newTenant': 'مستأجر جديد',
  'admin.actions.newLocation': 'موقع جديد',
  'admin.actions.newUser': 'مستخدم جديد',
  'admin.actions.newControllerVendor': 'مورد متحكم جديد',
  'admin.actions.newPmsVendor': 'مورد PMS جديد',
  'admin.actions.manageInfrastructure': 'البنية التحتية',
  'admin.actions.backToLocation': 'العودة إلى الموقع',
  'admin.actions.backToList': 'العودة إلى القائمة',
  'admin.actions.delete': 'حذف',
  'admin.infrastructure.inventory': 'مخزون الوحدات',
  'admin.infrastructure.roomAssignments': 'إسنادات الغرف الفردية',
  'admin.infrastructure.roomAssignmentsDesc':
    'يتم ربط كل غرفة بشكل فردي باستخدام SSID و VLAN ووضع PAN. استخدم هذه المنطقة لإنشاء أو تصحيح إسناد غرفة واحدة.',
  'admin.infrastructure.locationScopeDesc':
    'هذه الصفحة تابعة للموقع المحدد. تتم إدارة إسناد البنية التحتية مباشرة داخل الموقع.',
  'admin.infrastructure.sharedSpaces': 'وحدات مشتركة وقاعات فعاليات',
  'admin.infrastructure.noRooms': 'لا توجد غرفة مهيأة للموقع المحدد.',
  'admin.infrastructure.noSharedSpaces': 'لا توجد وحدة مشتركة مهيأة.',
  'admin.infrastructure.roomPreview': 'معاينة الإسناد',
  'admin.infrastructure.readiness': 'جاهزية التكامل',
  'admin.integrations.queuePlaceholder': 'سيتم تحديد Redis / RabbitMQ في الخلفية',
  'admin.integrations.pdsPlaceholder': 'لم يتم تحديد إعداد PDS بعد',
  'admin.form.createTenant': 'إنشاء مستأجر',
  'admin.form.updateTenant': 'تحديث المستأجر',
  'admin.form.tenantNotFound': 'المستأجر غير موجود.',
  'admin.form.createLocation': 'إنشاء موقع',
  'admin.form.updateLocation': 'تحديث الموقع',
  'admin.form.locationNotFound': 'الموقع غير موجود.',
  'admin.form.createUser': 'إنشاء مستخدم',
  'admin.form.updateUser': 'تحديث المستخدم',
  'admin.form.userNotFound': 'المستخدم غير موجود.',
  'admin.form.roomName': 'الغرفة',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'VLAN الخدمة',
  'admin.form.networkId': 'معرّف الشبكة',
  'admin.form.capacity': 'السعة',
  'admin.message.tenantSaved': 'تم حفظ المستأجر {name}.',
  'admin.message.tenantDeleted': 'تم حذف المستأجر {name}.',
  'admin.message.locationSaved': 'تم حفظ الموقع {name}.',
  'admin.message.locationDeleted': 'تم حذف الموقع {name}.',
  'admin.message.userSaved': 'تم حفظ المستخدم {name}.',
  'admin.message.userDeleted': 'تم حذف المستخدم {name}.',
  'admin.message.controllerVendorSaved': 'تم إنشاء مورد المتحكم {name}.',
  'admin.message.pmsVendorSaved': 'تم إنشاء مورد PMS {name}.',
  'admin.message.controllerVendorUpdated': 'تم تحديث مورد المتحكم {name}.',
  'admin.message.pmsVendorUpdated': 'تم تحديث مورد PMS {name}.',
  'admin.message.controllerVendorDeleted': 'تم حذف مورد المتحكم {name}.',
  'admin.message.pmsVendorDeleted': 'تم حذف مورد PMS {name}.',
  'admin.message.roomDeleted': 'تم حذف الغرفة {name}.',
  'admin.confirm.deleteTenant': 'حذف المستأجر {name} وكل المواقع المرتبطة به؟',
  'admin.confirm.deleteLocation': 'حذف الموقع {name} وبنيته التحتية؟',
  'admin.confirm.deleteUser': 'حذف المستخدم {name}؟',
  'admin.confirm.deleteRoom': 'حذف الغرفة {name}؟',
  'admin.confirm.deleteControllerVendor': 'حذف مورد المتحكم {name}؟',
  'admin.confirm.deletePmsVendor': 'حذف مورد PMS {name}?',
  'reception.tab.events': 'الفعاليات',
  'reception.actions.sendEmail': 'إرسال عبر البريد الإلكتروني',
  'reception.message.emailed': 'تم إرسال الرمز {id} عبر البريد الإلكتروني.',
  'events.kicker': 'شبكة Wi-Fi للفعاليات',
  'events.title': 'إنشاء وإدارة وصول الفعاليات',
  'events.name': 'اسم الفعالية',
  'events.hall': 'قاعة الفعالية',
  'events.duration': 'المدة',
  'events.code': 'رمز الفعالية',
  'events.isolation': 'عزل العملاء',
  'events.network.loading': 'جارٍ تحميل الشبكات...',
  'events.network.empty': 'لا توجد شبكات متاحة',
  'events.network.loadError': 'تعذر تحميل الشبكات',
  'events.isolated': 'معزول',
  'events.shared': 'وصول مشترك',
  'events.policy': 'السياسة',
  'events.contactName': 'اسم جهة الاتصال',
  'events.create': 'فعالية جديدة',
  'events.edit': 'تعديل الفعالية',
  'events.sendEmail': 'إرسال الرمز عبر البريد الإلكتروني',
  'events.disable': 'تعطيل الفعالية',
  'events.empty': 'لا توجد فعاليات مهيأة لهذا الموقع.',
  'reception.tab.hotel': 'الفندق', 'reception.hotel.description': 'رموز الغرف والمناطق المشتركة من PMS أو خدمة النزلاء', 'reception.hotel.kicker': 'رموز Wi-Fi للفندق', 'reception.hotel.title': 'إدارة رموز الغرف والمناطق المشتركة',
  'admin.onboarding.kicker': 'تسجيل موجّه للموقع', 'admin.onboarding.title': 'إنشاء موقع جديد وتهيئته', 'admin.onboarding.description': 'اتبع بالترتيب عملية التسليم من المورّد إلى Lumen.',
  'admin.onboarding.step1': 'المتحكم', 'admin.onboarding.step2': 'الموقع', 'admin.onboarding.step3': 'التكاملات', 'admin.onboarding.step4': 'المراجعة', 'admin.onboarding.step5': 'المراجعة',
  'admin.onboarding.locationKicker': 'الخطوة 2 · بيانات الموقع', 'admin.onboarding.locationTitle': 'أدخل بيانات الموقع الجديد',
  'admin.onboarding.controllerKicker': 'الخطوة 1 · اتصال المورّد', 'admin.onboarding.controllerTitle': 'تهيئة متحكم الموقع', 'admin.onboarding.controllerHelp': 'يجب إعداد الأجهزة والترددات ومجموعات AP ومعرّفات SSID الأساسية على منصة المورّد.',
  'admin.onboarding.integrationsKicker': 'الخطوة 3 · التكاملات الاختيارية', 'admin.onboarding.integrationsTitle': 'تهيئة PMS والتلفاز والبريد الإلكتروني', 'admin.onboarding.reviewKicker': 'الخطوة 4 · المراجعة', 'admin.onboarding.reviewTitle': 'تأكيد تهيئة الموقع', 'admin.onboarding.unitsNext': 'بعد الحفظ، هيئ الغرف والوحدات المشتركة وقاعات الفعاليات مع VLAN والشبكة.', 'admin.onboarding.saveContinue': 'حفظ وتهيئة الوحدات',
  'reception.fields.selectSpace': 'اختر وحدة',
  'reception.category.journalist': 'صحفي',
  'reception.category.relator': 'متحدث',
  'reception.categoryDescription.staff': 'يتم إنشاء الرمز على شبكة VLAN المحددة مسبقًا.',
  'reception.categoryDescription.iot': 'يتم إنشاء الرمز على شبكة VLAN المحددة مسبقًا.',
  'reception.categoryDescription.visitor': 'يتم إنشاء الرمز على شبكة VLAN المحددة مسبقًا.',
  'reception.categoryDescription.guest': 'اختر الغرفة لربط شبكة VLAN الخاصة بها.',
  'events.message.saved': 'تم حفظ الفعالية {name}.',
  'events.message.emailSent': 'تم إرسال رمز الفعالية إلى {email}.',
  'events.message.disabled': 'تم تعطيل الفعالية {name}.',
  'events.codes.kicker': 'إدارة الضيوف والزوار',
  'events.codes.manage': 'إدارة رموز الفعالية',
  'events.codes.type': 'نوع الرمز',
  'events.codes.mode': 'طريقة الإنشاء',
  'events.codes.personal': 'شخصي',
  'events.codes.manual': 'يدوي',
  'events.codes.bulk': 'استيراد جماعي',
  'events.codes.personalManual': 'شخصي · يدوي',
  'events.codes.personalBulk': 'شخصي · استيراد جماعي',
  'events.codes.group': 'مجموعة',
  'events.codes.manualTitle': 'إنشاء رمز شخصي',
  'events.codes.bulkTitle': 'استيراد رموز شخصية من ملف CSV',
  'events.codes.groupTitle': 'إنشاء رمز مجموعة',
  'events.codes.groupName': 'اسم المجموعة',
  'events.codes.sendEmail': 'إرسال الرمز عبر البريد الإلكتروني',
  'events.codes.service': 'الخدمة',
  'events.codes.serviceHint': 'استخدم شبكة VLAN المخصصة للخدمة والمهيأة لقاعة الفعالية.',
  'events.codes.serviceUnavailable': 'لا تحتوي القاعة المحددة على شبكة VLAN مهيأة للخدمة.',
  'events.codes.bulkHint': 'الأعمدة المطلوبة: firstName وlastName وemail وcategory وdevicesAllowed. يتم اعتماد المدة والقاعة من الفعالية، وتوضع المعالجة في قائمة انتظار للالتزام بحدود طلبات المورّد.',
  'events.codes.createPersonal': 'إنشاء رمز شخصي',
  'events.codes.createGroup': 'إنشاء رمز مجموعة',
  'events.codes.queueBulk': 'إضافة استيراد CSV إلى قائمة الانتظار',
  'events.codes.personalCreated': 'تم إنشاء الرمز الشخصي: {code}',
  'events.codes.groupCreated': 'تم إنشاء رمز المجموعة: {code}',
  'events.codes.bulkQueued': 'تمت إضافة الاستيراد {id} إلى قائمة الانتظار: تمت معالجة {imported} رمزًا.',
  'admin.unitsBulk.action': 'استيراد جماعي',
  'admin.unitsBulk.kicker': 'استيراد الوحدات جماعيًا',
  'admin.unitsBulk.title': 'استيراد الوحدات من CSV',
  'admin.unitsBulk.description': 'أنشئ الغرف والمساحات المشتركة وقاعات الفعاليات في عملية واحدة.',
  'admin.unitsBulk.loadFile': 'تحميل CSV',
  'admin.unitsBulk.csv': 'ملف CSV للوحدات',
  'admin.unitsBulk.hint': 'الأعمدة: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. المطلوبة: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'جارٍ الاستيراد...',
  'admin.unitsBulk.import': 'استيراد الوحدات',
  'admin.unitsBulk.completed': 'تم استيراد {count} وحدة.',
  'admin.unitsBulk.invalid': 'ملف CSV غير صالح: {error}',
  'admin.unitsBulk.noRows': 'لم يتم العثور على صفوف بيانات.',
  'admin.unitsBulk.missingColumns': 'الأعمدة المفقودة: {columns}.',
  'admin.unitsBulk.rowError': 'قيم غير صالحة في الصف {row}.',
};
